import { withRouter } from 'react-router-dom';

/**
 * Only use withRouter is build is a SPA
 * @param {*} component
 */
export const routerHOC = (component) => {
  return withRouter(component);
};
